import builtin from './assets/tags.json'

export default {
  builtin : builtin,

  addresses_for : function(tag){
    function check(registry){
      return Object.keys(registry).filter(function(a){
        return registry[a].includes(tag);
      });
    }

    const user = JSON.parse(localStorage.getItem('tags') || '{}');
    return check(builtin) + check(user);
  },

  builtin_tags_for : function(address){
    return builtin[address];
  },

  user_tags : function(){
    const user = JSON.parse(localStorage.getItem('tags') || '{}');
    return Array.from(new Set(Object.values(user).flat()));
  },

  user_tags_for : function(address){
    const user = JSON.parse(localStorage.getItem('tags') || '{}');
    return user[address];
  },

  addresses_for_user_tag : function(tag){
    const user = JSON.parse(localStorage.getItem('tags') || '{}');
    return Object.keys(user).filter(function(address){
      return user[address].includes(tag);
    });
  },

  tags_for : function(address){
    return (this.builtin_tags_for(address) || []).concat(this.user_tags_for(address) || []);
  },

  non_special_tags_for : function(address){
    return this.tags_for(address).filter(function(t){
             return !t.match(/Advisory Level.*/) &&
                    !t.match(/http.*/);
           });
  },

  advisory_level : function(address){
    const account_tags = this.tags_for(address);
    const advisory = account_tags.find(function(t){
                       return t.match(/Advisory Level.*/);
                     });

    if(!advisory) return null;
    return advisory[advisory.length - 1];
  },

  ///

  create_tag : function(address, tag){
    var tags = JSON.parse(localStorage.getItem('tags') || '{}');
    var addr_tags = new Set(tags[address] || []);
    addr_tags.add(tag);
    tags[address] = Array.from(addr_tags);
    localStorage.setItem('tags', JSON.stringify(tags));
  },

  rm_tag : function(address, tag){
    var tags = JSON.parse(localStorage.getItem('tags') || '{}');
    var addr_tags = tags[address] || [];
    addr_tags.splice(addr_tags.indexOf(tag), 1);
    tags[address] = Array.from(addr_tags);
    localStorage.setItem('tags', JSON.stringify(tags));
  },

  clear : function(){
    localStorage.removeItem('tags');
  }
}
